<template>
  <yxtf-dialog
    :visible.sync="dialogVisible"
    width="850px"
    :cutline="false"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    @open="init">
    <div class="medal-content">
      <div class="medal-content-bgimg " ref="container"></div>
      <div class="medal-content-container" v-if="dialogVisible">
        <div class="medal-desc">{{medalCountStr}}</div>
        <yxtf-image
          class="medal-icon"
          style="width: 200px; height: 200px"
          :src="currentMedal.icon"
          fit="contain"><div slot="placeholder" class="image-slot">
          loading...
        </div></yxtf-image>
      </div>
      <div
        v-if="medalList.length>1 && currentIndex>0" @click="moveLeft"
        class="medal-content-arrow_left"><yxtf-svg 
        width="24px"
        height="24px"
        icon-class="arrow_left"
        :remote-url="mediaPath"
      /></div>
      <div
        v-if="medalList.length>1 && currentIndex<medalList.length-1" @click="moveRight"
        class="medal-content-arrow_right"><yxtf-svg 
        width="24px"
        height="24px"
        icon-class="arrow_right"
        :remote-url="mediaPath" 
      /></div>
    </div>
    <div class="medal-content-bottom">
      <div class="medal-name">{{currentMedal.title}}</div>
      <yxtf-button size="other" type="primary" @click="close" class="medal-btn">{{currentMedal.btnName}}</yxtf-button>
    </div>
  </yxtf-dialog>
</template>

<script>
import lottie from 'lottie-web';
import * as animationData from './data.json';
import { getLanguage } from 'yxt-biz-pc/packages/common-util/changeLangs';
import { updateCustomMedalStatus } from './service';
export default {
  data() {
    return {
      dialogVisible: false,
      medalAnimation: null,
      mediaPath: `${this.$staticBaseUrl}ufd/407a24/reward/pc/svg`,
      medalList: [],
      currentIndex: 0,
      MedalName: {
        'live_learn': this.$t('pc_biz_medaldialog_lbl_livelearn'),
        'day_day_up': this.$t('pc_biz_medaldialog_lbl_daydayup'),
        'moods_king': this.$t('pc_biz_medaldialog_lbl_moodsking'),
        'accumulate_steadily': this.$t('pc_biz_medaldialog_lbl_accumulatesteadily')
      }
    };
  },
  props: {
    appName: {
      type: String,
      validator(value) {
        return ['kngpc', 'knglibpc', 'bbspc'].includes(value);
      }
    },
    lottieType: {
      type: String,
      validator(value) {
        return ['svg', 'canvas', 'html'].includes(value);
      },
      default: 'canvas'
    },
    medalList: {
      type: Array,
      default: ()=>[]
    }
  },
  computed: {
    isEN() {
      return getLanguage() === 'en';
    },
    medalCountStr() {
      // 恭喜获得{0}枚新勋章
      return this.$t('pc_biz_medaldialog_lbl_medalcount', {0: this.medalList.length});
    },
    animationJsonData() {
      const jsonStr = JSON.stringify(animationData.default);
      return JSON.parse(jsonStr.replace(/https:\/\/stc.yxt.com\//g, this.$staticBaseUrl));
    },
    currentMedal() {
      const temp = this.medalList[this.currentIndex];
      let medal = {};
      if (temp.type === undefined) {
        // 手动下发勋章，非IM
        medal = { ...temp, type: 1, btnName: this.$t('pc_biz_medaldialog_lbl_i_know' /* 我知道了 */) };
      } else {
        // IM勋章
        medal = {
          icon: temp.medalIcon,
          // 手动勋章：type-1；通用勋章：type-0，title显示格式：人气王+LV6+勋章
          title: temp.type === 1 ? temp.medalTitle : this.MedalName[temp.medalTemplateCode] + (this.isEN ? ' ' : '') + temp.medalTitle + (this.isEN ? ' ' : '') + this.$t('pc_biz_medaldialog_lbl_medal'),
          // '超赞！你已获得最高等级':'加油，向下一级迈进'
          btnName: temp.type === 1 ? this.$t('pc_biz_medaldialog_lbl_i_know' /* 我知道了 */) : (temp.topLevel === 1 ? this.$t('pc_biz_medaldialog_lbl_toplevel') : this.$t('pc_biz_medaldialog_lbl_nextlevel')),
          type: temp.type
        };
      }
      return medal;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    show() {
      this.dialogVisible = true;
      this.updateStatus();
    },
    // 更新勋章是否弹出的状态
    updateStatus() {
      if (this.medalList && this.medalList.length > 0 && this.medalList[0].medalDetailId) {
        // 弹出的是自定义勋章, 更新自定义勋章的弹出状态
        const ids = this.medalList.map(item => item.medalDetailId);
        updateCustomMedalStatus(ids);
      }
    },
    init() {
      this.$nextTick(function() {
        this.medalAnimation = lottie.loadAnimation({
          container: this.$refs.container,
          renderer: this.lottieType,
          loop: true,
          autoplay: true,
          animationData: this.animationJsonData
        });
      });
    },
    close() {
      this.currentIndex = 0;
      this.medalAnimation && this.medalAnimation.destroy();
      this.dialogVisible = false;
      this.$emit('closeDialog');
    },
    moveLeft() {
      this.currentIndex -= 1;
      if (this.currentIndex <= 0) {
        this.currentIndex = 0;
      }
    },
    moveRight() {
      this.currentIndex += 1;
      if (this.currentIndex >= (this.medalList.length - 1)) {
        this.currentIndex = this.medalList.length - 1;
      }
    }
  }
};
</script>
